var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "iq-indicator", attrs: { title: _vm.$t("title") } },
        [
          _c("div", { staticClass: "diamond" }),
          _vm._v(" "),
          _c("div", { staticClass: "caption" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("caption")) + "\n  ")
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/image-quality-indicator/IqIndicator.vue?vue&type=template&id=0e98bbca&scoped=true&
// module id = 427
// module chunks = 0